interface ValidateOrderModalProps {
  open: boolean;
  order: any | null;
  onClose: () => void;
  onConfirm: (order: any) => void;
}

export function ValidateOrderModal({
  open,
  order,
  onClose,
  onConfirm,
}: ValidateOrderModalProps) {
  if (!open || !order) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">
          Valider la commande
        </h3>

        <p className="text-gray-600 mb-6">
          Voulez-vous valider le bon de commande :
          <br />
          <span className="font-semibold text-gray-900">
            {order.numero}
          </span>
          ?
        </p>

        <div className="bg-blue-50 border border-blue-200 text-blue-800 text-sm rounded p-3 mb-6">
          ℹ️ Une fois validée :
          <ul className="list-disc ml-5 mt-1">
            <li>La commande ne pourra plus être modifiée</li>
            <li>Le stock pourra être réservé</li>
            <li>La commande sera prête pour la livraison</li>
          </ul>
        </div>

        <div className="flex justify-end gap-3">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
          >
            Retour
          </button>

          <button
            type="button"
            onClick={() => onConfirm(order)}
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
          >
            Confirmer la validation
          </button>
        </div>
      </div>
    </div>
  );
}
